<template>
  <div id="app">
    <Header></Header>
    <FixedWindow></FixedWindow>
    <router-view></router-view>
    <Right></Right>
  </div>
</template>

<script>
import Header from "@/components/public/Header";
import FixedWindow from "@/components/public/FixedWindow";
import Right from "@/components/public/Right";
// import Layout from "@/views/Layout";
export default {
  name: "App",
  components: {
    // Layout
    Header,
    FixedWindow,
    Right
  }
};
</script>

<style>
#app {
  color: #333;
  font-family: Arial, Microsoft YaHei, sans-serif !important;
  background-color: white;
  min-width: 1200px;
}
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: Arial, Microsoft YaHei, sans-serif !important;
}

p,
form,
img,
ul,
ol,
li,
dl,
dt,
dd {
  margin: 0;
  padding: 0;
  border: 0;
}
li {
  list-style-type: none;
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.vm {
  vertical-align: middle;
}
.tc {
  text-align: center;
}
.font14 {
  font-size: 14px;
}
.font15 {
  font-size: 15px;
}
.font16 {
  font-size: 16px;
}
.font12 {
  font-size: 12px;
}
.h100 {
  height: 100%;
}
.w100 {
  width: 100%;
}
.abm {
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
}
.abmc {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
}
a {
  transition: all 0.2s !important;
}
</style>
